var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.show, persistent: "", "max-width": "440" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "text-h6" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _vm._v(" Sessão alterada em outra aba "),
            ],
            1
          ),
          _c("v-card-text", [
            _vm._v(
              " O período letivo foi alterado em outra aba. Recarregue a página para continuar. "
            ),
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.reload } },
                [_vm._v("Recarregar")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }